import { render, staticRenderFns } from "./headersView.vue?vue&type=template&id=2ecf376c&scoped=true"
import script from "./headersView.vue?vue&type=script&lang=js"
export * from "./headersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf376c",
  null
  
)

export default component.exports